import SimplePointDataTable from '@components/_shared/SimplePointDataTable';
import { useDataPointsSubscription } from '@hooks/mqtt/useDataPointsSubscription';
import { Grid2 } from '@mui/material';
import { DataPoint, DataPointWithValue } from '@src/types/DataPoint';
import { createDataPointsMap } from '@utils/dataPoints';
import { useMemo } from 'react';

interface Props {
  dataPointsMatrix: DataPoint[][];
}

function MultiColPointDataTable({ dataPointsMatrix }: Props) {
  const allDataPoints = useMemo(
    () => dataPointsMatrix.flat(),
    [dataPointsMatrix],
  );

  const allDataPointsWithValues = useDataPointsSubscription(allDataPoints);

  const dataPointsMatrixWithValues = useMemo(() => {
    const dataPointsMap = createDataPointsMap(allDataPointsWithValues);

    return dataPointsMatrix.map((columnDataPoints) =>
      columnDataPoints.map<DataPointWithValue>((dataPoint) => {
        const existingDataPoint = dataPointsMap.get(dataPoint.fullTopic);

        return (
          existingDataPoint ?? {
            ...dataPoint,
            value: undefined,
            ts: undefined,
          }
        );
      }),
    );
  }, [dataPointsMatrix, allDataPointsWithValues]);

  // Calculate column width once
  const columnWidth = useMemo(
    () => Math.floor(12 / dataPointsMatrix.length),
    [dataPointsMatrix.length],
  );

  return (
    <>
      {dataPointsMatrixWithValues.map((columnSectionDataPoints, index) => (
        <Grid2 size={{ xs: columnWidth }} key={index}>
          <SimplePointDataTable data={columnSectionDataPoints} />
        </Grid2>
      ))}
    </>
  );
}

export default MultiColPointDataTable;
